import Outbrain from './outbrain'

const outbrain = new Outbrain()
outbrain.init()
